<template>
    <div>
        <div class="text-center">
            <h3 class="mt-0">Conditions d'utilisation</h3>
            <p class="m-0">Activix Inc. ▪ Version 01.12</p>
            <p class="m-0">Date d’entrée en vigueur : 1er Décembre 2017</p>
        </div>
        <div class="text-justify">
            <h4>1. Conditions générales</h4>
            <p>
                <strong>1.1.</strong> Les présentes conditions d’utilisation (ci-après les «
                <strong>Conditions</strong> ») détaillent vos droits et obligations afférents à
                l’accès et l’utilisation des produits et servicesque vous fournit Activix Inc (ci
                après les « <strong>Produits</strong> »)., ainsi que les transactions et achats
                effectués. Ces produits incluent, entre autres, NioText.
            </p>
            <p>
                IL VOUS APPARTIENT DE LIRE ATTENTIVEMENT LES PRÉSENTES CONDITIONS ET D’Y CONSENTIR
                AVANT D’UTILISER LES PRODUITS.
            </p>
            <p>
                En accédant ou en utilisant les Produits ou leurs fonctionnalités, de même qu’en
                manifestant votre consentement sous une autre forme, vous acceptez d’être lié par
                les dispositions des Conditions et des documents auxquels les Produits renvoient.
                Ces Conditions vous lient autant pendant, qu’après votre utilisation des Produits
            </p>
            <p>
                À DÉFAUT D’ACCEPTER L’INTÉGRALITÉ DES CONDITIONS OU TOUTE MODIFICATION AUX
                CONDITIONS, VOUS DEVEZ CESSER D’UTILISER LES PRODUITS IMMÉDIATEMENT.
            </p>
            <p>
                Nous vous invitons également à nous contacter pour toute question ou commentaire
                relatifs aux Conditions à info@activix.ca
            </p>

            <p><strong>1.2.</strong> Définitions</p>
            <p>
                « <strong><em>Activix</em></strong> », « <strong><em>nos</em></strong> », «
                <strong><em>nous</em></strong> » ou « <strong><em>notre</em></strong> »
                <strong>→</strong> renvoie à l’entreprise Activix Inc.
            </p>
            <p>
                « <strong><em>Produits</em></strong> » <strong>→</strong> renvoient aux produits
                web, applications mobiles ou autres développés par Activix et disponibles pour les
                Clients Activix sur différentes plateformes ;
            </p>
            <p>
                « <strong><em>Clients Activix</em></strong> » <strong>→</strong> signifie les
                clients payants qui ont souscrit à un service commercial offert par Activix Inc. en
                sus des Produits ;
            </p>
            <p>
                « <strong><em>Communication(s) Non-sollicitée(s)</em></strong> »
                <strong>→</strong> a le sens qui lui est donné à l'article 4.1
            </p>
            <p>
                « <strong><em>Conditions</em></strong> » <strong>→</strong> signifie les présentes
                conditions d’utilisation exposées dans ce document ;
            </p>
            <p>
                « <strong><em>Conditions Additionnelles</em></strong> » <strong>→</strong> a le sens
                qui lui est donné à l'article 1.4
            </p>
            <p>
                « <strong><em>Contenu</em></strong> » <strong>→</strong> signifie tout texte, image,
                fichier audio, vidéo, élément multimédia divers, logiciel, code, ou tout autre
                information ou matériel publié, existant, étant accessible ou étant envoyé à partir
                des Produits;
            </p>
            <p>
                « <strong><em>Services</em></strong> » <strong>→</strong> renvoient à l’intégralité
                des services offerts par les Produits et par Activix, accessibles par l’accès aux
                Produits via différentes plateformes.
            </p>
            <p>
                « <strong><em>Utilisateur</em></strong> », « <strong><em>vous</em></strong> », «
                <strong><em>vos</em></strong> » ou « <strong><em>votre</em></strong> »
                <strong>→</strong> renvoi à la personne, physique ou morale, accédant ou utilisant
                les Produits, les Services ou leurContenu ;
            </p>
            <p>
                <strong>1.3.</strong> Politique de confidentialité : Les présentes Conditions
                incluent votre acceptation des modalités prévues à notre Politique de
                confidentialité. Cette Politique est également régie par les présentes Conditions
                dans le cas où un litige ou une incohérence relative à ladite politique
                surviendrait.
            </p>
            <p>
                <strong>1.4.</strong> Conditions Additionnelles : Les présentes Conditions peuvent
                être modifiées ou remplacées par des Conditions Additionnelles afférentes au Contenu
                ainsi qu’aux services offerts par les Produits (ci-après les «
                <strong>Conditions Additionnelles</strong> »). Ces Conditions Additionnelles
                remplaceront toute modalité antérieure avec lesquelles elles seraient en conflit ou
                incompatible.
            </p>
            <p>
                <strong>1.5.</strong> Les Produits sont destinés aux résidents canadiens âgés de 18
                ans et plus.
            </p>

            <h4>2. Restrictions d’utilisation</h4>
            <p>
                <strong>2.1.</strong> Les Produits sont destinés pour l’utilisation commerciale de
                votre compte client avec Activix. Lorsque vous accédez ou utilisez les Produits,
                vous acceptez :
            </p>
            <p>
                <strong>2.1.1.</strong> de ne pas utiliser les Produits à des fins illégales en
                vertu des lois applicables ou en vertu des présentes Conditions ;
            </p>
            <p>
                <strong>2.1.2.</strong> de ne pas diffamer, dénigrer ou faire tout commentaire de
                nature obscène, dérogatoire ou offensive ou bien d’utiliser ces Produits ou leur
                Contenu de nature à générer un litige avec nous ou tout autre tiers, notamment un
                litige qui engagerait notre responsabilité ou celle d’un tiers ;
            </p>
            <p>
                <strong>2.1.3.</strong> de ne pas supprimer ou réviser le Contenu des Produits
                lorsque ledit contenu n’émane pas de vous ;
            </p>
            <p>
                <strong>2.1.4.</strong> de ne pas décompiler, désassembler, adapter, traduire,
                transmettre, arranger, modifier, copier, regrouper, vendre sous-licence, exporter,
                fusionner, transférer, adapter, prêter, louer, céder, partager, externaliser,
                héberger, publier, rendre les Produits disponibles sur une tierce plateforme (tel
                que par des procédés d’hyperliens (« <em>linking</em> »), d’encadrement («
                <em>framing</em> ») ou de robots d’indexation (« <em>spidering</em> »), renvoyer à
                des liens profonds, créer du contenu dérivé ou exploiter ces Produits ou leur
                Contenu de manière contraire aux présentes Conditions, aux lois en vigueur, de même
                qu’à toute autre Condition Additionnelle, et ce, sous quelque forme ou par quelque
                moyen que ce soit : physiques, électroniques ou autre ;
            </p>
            <p>
                <strong>2.1.5.</strong> de ne pas envoyer toute forme de message électronique non
                sollicité (« <em>spam</em> »), commercial ou autre.
            </p>
            <p>
                <strong>2.1.6.</strong> de ne pas utiliser les Produits ou leur Contenu afin de
                distribuer des virus informatiques, malicieux ou tout autre programme ou code
                malveillant;
            </p>
            <p>
                <strong>2.1.7.</strong> de ne pas tenter de sonder, analyser ou tester la
                vulnérabilité des Produits ou de son réseau et de ne pas tenter de violer le système
                ou réseau de sécurité ou d’authentification, de même que toute autre mesure de
                sécurité des Produits ;
            </p>
            <p>
                <strong>2.1.8.</strong> de ne pas présenter et de ne pas suggérer ou laisser croire
                que nous recommandons, une personne, physique ou morale, à moins d’obtenir une
                autorisation écrite distincte de notre part à cet effet ;
            </p>
            <p>
                <strong>2.1.9.</strong> de ne pas accéder à des données non destinées à vous ou de
                vous connecter à un serveur ou un compte auquel vous n’êtes pas autorisé à accéder ;
            </p>
            <p>
                <strong>2.1.10.</strong> d’être tenu responsable de tous les coûts, honoraires,
                frais et dépens qui pourraient être générés par votre utilisation des Produits.
            </p>
            <p>
                <strong>2.2.</strong> Seuls les Clients Activix sont autorisés à utiliser les
                Produits à des fins commerciales, et ce, uniquement par le biais des Services
                connexes aux Produits ou en renvoyant aux Produits par des procédés d’hyperliens. En
                aucun temps, un Client Activix n’est autorisé à utiliser le Contenu à l’extérieur
                des Produits ou d’un service connexe offert par Activix Inc., à moins d’une
                disposition explicite à cet effet.
            </p>
            <p>
                <strong>2.3.</strong> Nous nous réservons le droit de prévenir ou suspendre l’accès
                partiel ou complet à nos Produits si un Utilisateur ne respecte pas les présentes
                Conditions, de même que toute loi ou règlement en vigueur.
            </p>

            <h4>3. Propriété, utilisation et droit de propriété intellectuelle</h4>
            <p>
                <strong>3.1.</strong> Le Contenu d’Activix Inc. est protégé par les droits d’auteurs
                Canadiens et étrangers, des marques de commerce et d’autres lois. Sauf disposition
                contraire, le Contenu des Produits est la propriété d’Activix Inc., ses clients
                et/ou de ses fournisseurs. L’utilisation non autorisée du Contenu d’Activix Inc.
                peut violer les droits d’auteurs, marques de commerce et d’autres lois. Activix Inc.
                peut modifier ou supprimer tout ou partie du Contenu des Produits à sa seule
                discrétion, à tout moment et sans préavis.
            </p>
            <p>
                <strong>3.2.</strong> Ces Produits ainsi que tous les droits de propriété
                intellectuelle afférents (notamment leur Contenu) sont et demeurent notre propriété
                exclusive ou celle de nos concédants. Nos concédants et nous-mêmes réservons tous
                nos droits de propriété intellectuelle (incluant notamment tout droit d’auteur,
                marques de commerce, nom de domaine, droits de conception, droits de base de
                données, brevets ainsi que tout autre droit de propriété intellectuelle) sans égard
                à l’enregistrement de ces droits dans quelconque pays.
            </p>
            <p>
                <strong>3.3.</strong> Aucune disposition des Conditions ne vous octroie quelconque
                droit dans les Produitsautre que ce qui est nécessaire pour y accéder. Vous acceptez
                de ne pas essayer de contourner ou de supprimer tout avis de propriété
                intellectuelle figurant sur les Produits, dont les droits numériques ou d'autres
                droits de sécurité technologique publiés sur les Produits.
            </p>

            <h4>4. Communications sur les Produits</h4>
            <p>
                <strong>4.1.</strong> Les Produits et leurs Services n’offrent pas un moyen de
                communication sécurisé et toute information que vous fournissez ne sera pas
                considérée comme confidentielle. Pour cette raison, vous ne devriez pas nous
                envoyer, ni communiquer entre utilisateurs, des idées brevetables ou demandes de
                brevets, des suggestions de publicité ou de marketing, des prototypes ou toute autre
                information écrite ou verbale, que vous considérez comme confidentielles ou
                commercialement sensibles ou de valeurs commerciales (collectivement désignés
                ci-après « <strong>Communications Non-sollicitées</strong> »). Bien que nous
                apprécions vos commentaires, vous acceptez de ne pas nous envoyer de telles
                Communications Non-sollicitées. Toute communication, y compris toute Communication
                Non-sollicitée, qui nous est envoyée, communiquée par le biais de nos Services ou
                publiée sur nos Produits est réputée être notre propriété. En nous transmettant ou
                en publiant sur les Produits une communication et/ou une information, de même que
                tout autre élément, vous acceptez, sous réserve de notre Politique de
                confidentialité, que nous utilisions ces informations de quelque manière que ce soit
                (y compris la reproduction, la transmission, l’enregistrement, la publication, la
                diffusion et l'affichage sur tout support et partout dans le monde), et ce,
                gratuitement. Vous acceptez également que nous ne soyons soumis à aucune obligation
                de confidentialité, ni pouvant être tenus responsables de toute utilisation et/ou
                divulgation du Contenu de ces communications.
            </p>
            <p>
                <strong>4.2.</strong> Lorsque les Produits vous permettent de communiquer avec nous
                et/ou d'autres Utilisateurs des Produits, vous ne pouvez pas utiliser les Produits
                pour communiquer du contenu ou du matériel blessant ou offensant (ex. du contenu
                violent, obscène, discriminatoire, diffamatoire ou autrement contraire à la bonne
                foi) ou illégal. Bien que nous nous réservions le droit de modérer, surveiller,
                modifier, réviser ou supprimer les avis, commentaires, discussions, chats,
                publications, transmissions, forums et communications similaires sur les Produits de
                temps à autre, nous ne sommes pas tenus de le faire et nous n’assumons aucune
                responsabilité découlant de tout contenu affiché sur les Produits ou communiqué via
                ceux-ci, ni pour toute erreur, omission, infraction, déclaration diffamatoire,
                obscène ou inexacte contenue dans ces communications.
            </p>
            <p>
                <strong>4.3.</strong> En utilisant et en accédant aux Produits, vous déclarez et
                garantissez que tout Contenu que vous nous fournissez est et demeure votre propre
                œuvre originale, qu’un tel Contenu nous a légalement été fourni, que vous détenez
                toutes les autorisations nécessaires pour nous fournir un tel Contenu et que vous
                nous autorisez à divulguer votre nom en lien avec un tel Contenu. En nous
                fournissant ce Contenu, vous renoncez à tous les droits moraux auxquels vous
                pourriez prétendre et acceptez que tous les renseignements personnels que vous
                fournissez à même votre Contenu pourraient puissent être réutilisés par nous, sous
                réserve de notre Politique de confidentialité.
            </p>

            <h4>
                5. Dispositions applicables à la création et à l’utilisation des services avec un
                compte
            </h4>
            <p>
                <strong>5.1.</strong> Lorsqu’un compte vous est crée pour nos Produits, vous
                comprenez et acceptez que vous êtes le seul responsable du maintien de la
                confidentialité de votre compte, y compris votre mot de passe, et êtes entièrement
                responsable de toutes les activités qui se produisent sous ce compte, qu’elles aient
                été voulues ou non par vous.
            </p>
            <p><strong>5.2.</strong> Vous vous engagez à :</p>
            <p>
                <strong>5.2.1.</strong> nous aviser de toute utilisation non autorisée de votre
                compte ou de toute autre violation de sécurité sans délai; et,
            </p>
            <p>
                <strong>5.2.2.</strong> vous déconnecter de votre compte à la fin de chaque
                utilisation.
            </p>
            <p>
                <strong>5.3.</strong> Après que votre compte ait été créé sur nos Produits, vous
                devenez habile à utiliser les Produits pour leur fonctionnalité, en connexion avec
                les autres produits ou services d’Activix Inc.;
            </p>
            <p>
                <strong>5.4.</strong> Vous déclarez et garantissez que les propriétaires des numéros
                de téléphone auxquels vous envoyez des messages ou fichiers par le biais de nos
                Services et des Produits ont consenti ou ont choisi d’accepter la réception de ces
                messages conformément à toute loi ou disposition applicable.
            </p>
            <p>
                <strong>5.5.</strong> Vous déclarez et garantissez que vous notifiez toute personne
                morale ou physique de l'enregistrement de leurs appels effectués via nos Produits et
                pour toute conservation de ces enregistrements. Vous acceptez également de vous
                conformer à toute loi relative à l'enregistrement des appels téléphoniques.
            </p>
            <p>
                <strong>5.6.</strong> Vous acceptez de vous soumettre à toute loi relative à l’envoi
                de messages SMS et MMS et aux meilleures pratiques commerciales lors de
                l’utilisation de nos Services et de nos Produits
            </p>
            <p>
                <strong>5.7.</strong> Vous comprenez que tout Contenu, qu’il soit affiché
                publiquement sur les Produits ou transmis de manière privée par l’utilisation de nos
                Services, est la seule responsabilité de la personne dont il provient. Cela signifie
                que l’Utilisateur, le Client Activix, et non Activix Inc. ou toutes autres filiales
                et partenaires, sont entièrement responsables :
            </p>
            <p>
                <strong>5.7.1.</strong> du Contenu qu’ils publient, transmettent ou rendent
                autrement disponible par le biais de nos Services; et,
            </p>
            <p>
                <strong>5.7.2.</strong> de veiller à ce que leur Contenu soit précis, sans
                information trompeuse et qu’ils n’enfreignent aucun droit de propriété
                intellectuelle appartenant à quiconque.
            </p>
            <p>
                <strong>5.8.</strong> Nous n’avons aucun contrôle sur le Contenu transmis via nos
                Services et Produits et nous ne pouvons pas garantir l'exactitude, l'intégrité ou la
                qualité du Contenu qui est transmis ou communiqué. Conséquemment, vous acceptez de
                ne pas nous tenir responsable de quelconque inexactitude, erreur ou omission
                relative au Contenu de même que toute perte ou dommage, de quelque nature que ce
                soit, résultant de l'utilisation ou de la confiance envers le Contenu affiché,
                publié, transmis ou autrement mis à la disposition des Utilisateurs via nos Services
                et Produits.
            </p>
            <p>
                <strong>5.9.</strong> Vous reconnaissez que nous n’effectuons aucune une
                vérification préalable au Contenu affiché, publié ou transmis par un Utilisateur ou
                Client Activix, mais que nous nous réservons le droit (mais pas l'obligation) de
                refuser ou de supprimer tout Contenu rendu disponible via nos Services et Produits,
                qui viole les présentes Conditions, ou que nous estimons répréhensible, et ce, à
                notre seule discrétion.
            </p>
            <p>
                <strong>5.10.</strong> Vous reconnaissez et acceptez expressément que nous
                autorisons l'accès, préservions et divulguions de l'information ainsi que le Contenu
                afférent à votre compte lorsque requis par la loi, une ordonnance judiciaire, et
                même de bonne foi, si nous estimons que l’accès, la préservation ou la divulgation
                est raisonnablement nécessaire pour :
            </p>
            <p><strong>5.10.1.</strong> se conformer à une ordonnance judiciaire ;</p>
            <p><strong>5.10.2.</strong> faire respecter les présentes Conditions ;</p>
            <p>
                <strong>5.10.3.</strong> répondre aux allégations de violation des droits de tierces
                personnes ;
            </p>
            <p><strong>5.10.4.</strong> répondre à vos demandes de service à la clientèle ; ou,</p>
            <p>
                <strong>5.10.5.</strong> protéger nos droits, notre propriété, la sécurité
                personnelle de nos employés, la sécurité de notre organisation et ses sociétés
                affiliées, les Utilisateurs et le public.
            </p>
            <p>
                <strong>5.11.</strong> Lorsque vous créez un compte ou que vous communiquez avec un
                tiers via nos Produits, vous vous engagez à ne pas :
            </p>
            <p>
                <strong>5.11.1.</strong> téléverser, afficher, communiquer, transmettre par
                messagerie, courriel ou de toute autre manière tout Contenu :
            </p>
            <p>
                <strong>(i)</strong> qui est faux, inexact, trompeur, diffamatoire, nuisible,
                menaçant, abusif, harcelant, discriminatoire, vulgaire, obscène, haineux, raciste ou
                autrement répréhensible ou illégal ;
            </p>
            <p>
                <strong>(ii)</strong> pour lequel vous ne disposez pas des droits de mettre un tel
                Contenu disponible en vertu de toute loi, toute relation contractuelle ou
                fiduciaire;
            </p>
            <p>
                <strong>(iii)</strong> qui porte atteinte à un brevet, une marque de commerce, un
                secret commercial, un droit d'auteur ou tout autre droit de propriété appartenant à
                une tierce partie ;
            </p>
            <p>
                <strong>(iv)</strong> qui constitue de la publicité non-sollicitée ou non autorisée,
                du matériel promotionnel (« <em>junk mail</em> », « <em>spam</em> », «
                <em>chaînes de lettres</em> », « <em>systèmes pyramidaux</em> ») ou toute autre
                forme de sollicitation illégale ou contraire aux présentes Conditions ;
            </p>
            <p>
                <strong>5.11.2.</strong> usurper l'identité d'une personne, physique ou morale, y
                compris mais sans s'y limiter, un membre de notre personnel ou faussement déclarer
                une supposée affiliation avec telle personne ;
            </p>
            <p>
                <strong>5.11.3.</strong> transférer votre compte à une autre personne sans notre
                autorisation préalable ;
            </p>
            <p>
                <strong>5.11.4.</strong> colliger, recueillir, utiliser ou divulguer des
                renseignements personnels sur les utilisateurs, y compris les adresses courriels,
                sans leur consentement préalable ou en dérogeant aux lois applicables en semblable
                matière ;
            </p>
            <p>
                <strong>5.11.5.</strong> entreprendre toute action qui nous imposerait un fardeau
                déraisonnable ou disproportionné sur notre infrastructure numérique ou celles de nos
                filiales ;
            </p>
            <p>
                <strong>5.11.6.</strong> interférer ou essayer d’interférer avec le bon
                fonctionnement de nos Services ou de nos Produits.
            </p>
            <p>
                <strong>5.12.</strong> Vous reconnaissez que nous pouvons établir des pratiques
                générales et des limites concernant l'utilisation des Services, y compris, mais sans
                s'y limiter, le nombre maximal de jours que votre Contenu sera conservé sur nos
                Produits, la limite de Contenu par compte, la taille maximale du message ou du
                Contenu qui peut être émis par un compte, le nombre maximal de fois et, la durée
                maximale pour laquelle vous pouvez accéder ou utiliser les Services dans une période
                de temps donné. Vous reconnaissez, en outre, que nous nous réservons le droit de
                modifier ces pratiques et limites générales à tout moment, à notre seule discrétion,
                avec ou sans préavis.
            </p>
            <p>
                <strong>5.13.</strong> Sans limiter notre droit à tout autre recours, nous pouvons,
                à notre seule discrétion, limiter, suspendre ou résilier les Services et les comptes
                d'Utilisateurs (incluant les comptes de Clients Activix), d'interdire l'accès aux
                Produits et prendre des mesures techniques et juridiques afin d’empêcher certains
                Utilisateurs d’accéder à aux Produits de même que de retirer et supprimer tout
                Contenu et Services, pour une raison qui nous est propre, y compris, mais sans s'y
                limiter, lorsque :
            </p>
            <p>
                <strong>5.13.1.</strong> les comptes n’ont pas été confirmés par l’Utilisateur ou le
                Client Activix ou qui ont été inactifs pendant une période de plus de six (6) mois ;
            </p>
            <p>
                <strong>5.13.2.</strong> nous estimons que vous avez violé ou agi de manière
                incompatible avec les Conditions ou l'esprit des Conditions ;
            </p>
            <p>
                <strong>5.13.3.</strong> nous y sommes contraints par une loi, un tribunal compétent
                ou tout autre organisme gouvernemental ayant un tel pouvoir contraignant ;
            </p>
            <p>
                <strong>5.13.4.</strong> vous fournissez des informations fausses, inexactes,
                périmées ou incomplètes ou lorsque que nous détenons des motifs raisonnables de
                soupçonner que vous avez commis de tels actes ;
            </p>
            <p><strong>5.13.5.</strong> vous nous en faites la demande ;</p>
            <p>
                <strong>5.13.6.</strong> nous devons interrompre ou apporter des modifications
                matérielles aux Services ;
            </p>
            <p>
                <strong>5.13.7.</strong> surviennent des problèmes techniques ou de sécurité
                imprévus ;
            </p>
            <p>
                <strong>5.13.8.</strong> vous avez ou nous croyons que vous avez commis des
                activités illégales, y compris, sans limitation, la fraude; et/ou,
            </p>
            <p>
                <strong>5.13.9.</strong> vous enfreignez notre Politique de confidentialité ou des
                lois de protection de renseignements personnels en vigueur.
            </p>
            <p>
                <strong>5.14.</strong> Vous reconnaissez et acceptez que toute résiliation de votre
                accès aux Services en vertu d'une disposition des présentes Conditions peut être
                effectuée sans préavis et que nous pouvons immédiatement désactiver ou supprimer
                votre compte et tout le Contenu y afférent. Conséquemment, vous acceptez de ne pas
                pouvoir nous tenir responsables envers vous ou un tiers pour la résiliation de votre
                compte, ou à la résiliation de votre accès aux Services.
            </p>

            <h4>6. Création de comptes</h4>
            <p>
                <strong>6.1.</strong> Si vous n’êtes pas un Client Activix, vous ne pouvez pas
                utiliser nos Produits.
            </p>
            <p>
                <strong>6.2.</strong> Alors que nous nous efforçons de maintenir les Produits
                disponibles en tout temps, il est possible que l’un ou certains de nos Produits
                soient momentanément indisponibles pour une période de 12 heures par semaine, de
                façon continue ou discontinue, pour des raisons techniques.
            </p>
            <p>
                <strong>6.3.</strong> Dans l’hypothèse où une fonctionnalité payante des Produits
                serait défectueuse pour une période prolongée, il se peut que nous ayons à remplacer
                cette fonctionnalité par un service alternatif de valeur égale ou supérieure. Le cas
                échéant, nous communiquerons avec vous afin de vous faire part de nos intentions.
            </p>
            <p>
                <strong>6.4.</strong> Nous faisons tout ce qui est raisonnablement possible pour
                veiller à ce que toutes les informations que vous fournissez lors du paiement soient
                protégées à l'aide d'un mécanisme de paiement sécurisé crypté, mais en l'absence de
                négligence de notre part, nous ne pouvons pas être tenus responsables pour toute
                perte que vous pourriez subir si un tiers accède aux informations que vous nous
                fournissez.
            </p>
            <p>
                <strong>6.5.</strong> La fin d’un contrat de service avec les Clients Activix ne
                peut porter atteinte à toute créance nous étant due en vertu des Conditions.
            </p>

            <h4>7. Exactitude du Contenu et disponibilité des Produits</h4>
            <p>
                <strong>7.1.</strong> Bien que nous nous efforcions de maintenir des informations
                exactes et à jour sur nos Produits, nous ne pouvons offrir aucune garantie que le
                Contenu est ou demeure disponible, exact, complet, fiable, exhaustif, actuel et à
                jour, de même que nos Services sont exempts de bogues, d’erreurs et d’omissions.
            </p>
            <p>
                <strong>7.2.</strong> La confiance et la fiabilité que vous attribuez au Contenu de
                ces Produits sont à vos propres risques et périls. Nous pouvons suspendre ou mettre
                fin au fonctionnement des Produits à tout moment et à notre seule discrétion.
            </p>
            <p>
                <strong>7.3.</strong> Aucune disposition des présentes Conditions ne peut porter
                préjudice à nos droits et obligations statutaires.
            </p>

            <h4>8. Politique de notification et retrait pour Contenu illicite</h4>
            <p>
                <strong>8.1.</strong> En cas de réclamation ou d'objection de votre part quant au
                Contenu publié sur les Produits, ou si vous croyez que des éléments du Contenu ou
                des messages envoyés violent vos droits d'auteur, vous acceptez de nous aviser
                immédiatement et de ne pas nous tenir responsables de tout dommage et toute
                réclamation qui pourraient survenir lorsque votre demande est traitée dans un délai
                de dix (10) jours ouvrables.
            </p>

            <h4>9. Hyperliens et tiers</h4>
            <p>
                <strong>9.1.</strong> Les Produits peuvent contenir des hyperliens, des références
                ou renvois à des applications de tiers. Tous ces hyperliens, références ou renvois
                sont fournis pour votre seule commodité. Nous n'avons aucun contrôle sur le contenu
                des applications des tiers et nous ne pouvons assumer aucune responsabilité pour
                tout contenu, matériel ou information qu'ils contiennent. La publication
                d’hyperliens, références ou renvois, à une application d’un tiers, ne constitue pas
                une approbation du contenu de cette application, des produits ou services de ces
                tiers.
            </p>
            <p>
                <strong>9.2.</strong> Votre utilisation d'une application d’un tiers peut être régie
                par des conditions propres à cette application.
            </p>

            <h4>10. Limitation de responsabilité</h4>
            <p>
                <strong>10.1.</strong> Les Produits peuvent transmettre les messages et fichiers qui
                ont été initiés par vous ou envoyés par vous à des tiers de votre choix en plus
                d’enregistrer vos conversations téléphoniques avec ces tiers, entre autres. Ainsi,
                vous acceptez de ne pas nous tenir responsables pour le Contenu, les messages, les
                actions ou les inactions qui sont faits par vous en utilisant nos Produits ou nos
                Services. Nous n’avons aucun contrôle sur les Utilisateurs ou Clients Activix
                utilisant les Produits et nous ne pouvons pas garantir la véracité, la qualité, la
                sécurité ou la légalité du Contenu. Nous ne pouvons pas garantir un accès continu ou
                sécurisé à nos services, et le fonctionnement de nos Produits peut être affecté par
                de nombreux facteurs hors de notre contrôle.
            </p>
            <p>
                <strong>10.2.</strong> Vous êtes responsables de l’obtention et du maintien de tout
                le matériel informatique, logiciels et appareils mobiles nécessaires pour accéder
                aux Produits et aux Services ainsi que de toutes les charges de télécommunications
                facturés par votre fournisseur de téléphonie sans fil pour l’utilisation des
                Services.
            </p>
            <p>
                <strong>10.3.</strong> Vous comprenez et acceptez que nous ne sommes pas
                responsables de toute perte encourue par l’échec d’un message et des dommages pour
                perte financière ou autre résultant d’un échec de livraison ne peut nous être
                réclamé. De plus, vous comprenez et acceptez que nous ne sommes pas responsables
                pour toute perte, procédure judiciaire ou litige contre vous suite à votre
                enregistrement illégal de vos conversations téléphoniques avec des tiers.
            </p>
            <p>
                <strong>10.4.</strong> Vous comprenez et acceptez que nous sommes seulement
                responsables que vos messages et fichiers soient traités correctement et transmis au
                réseau applicable. Nous ne pouvons pas être tenus responsables de la livraison
                finale de toute communication ou message initié par le biais de nos Produits et de
                nos Services, car cela est hors de notre contrôle. De plus, nous ne pouvons pas être
                tenus responsables du délai de transmission de toute communication ou message initié
                par le biais de nos Produits et de nos Services. Ces délais dépendent de plusieurs
                facteurs reliés aux réseaux sans-fil, lignes téléphoniques et connexion Internet des
                Utilisateurs.
            </p>
            <p>
                <strong>10.5.</strong> Dans les limites prévues par la loi, vous comprenez et
                acceptez que nos concédants de licence et nous-mêmes ne pouvons pas être tenus
                responsables des dommages directs, indirects, accessoires, spéciaux, consécutifs ou
                exemplaires que vous pouvez encourir en vertu des principes de la responsabilité
                civile. Cela inclut notamment les dommages pour perte de profits et de clientèle,
                atteinte à votre réputation, la perte de données, le coût d'acquisition de biens ou
                de services de substitution ou toute autre perte intangible (même si nous avons été
                informés de la possibilité de tels dommages), résultant de votre utilisation ou de
                votre impossibilité d'utiliser nos Services ou toute matière relative à nos Services
                et nos Produits.
            </p>
            <p>
                <strong>10.6.</strong> Nonobstant ce qui précède, si nous sommes jugés responsables,
                notre responsabilité envers vous ou à une tierce partie est limitée au plus élevé
                des montants suivants :
            </p>
            <p>
                <strong>10.6.1.</strong> le total des frais que vous nous avez payés dans les 12
                mois précédant l'action donnant lieu à la responsabilité ; et,
            </p>
            <p><strong>10.6.2.</strong> $ 150,00 CAD.</p>
            <p>
                <strong>10.7.</strong> Vous acceptez que votre utilisation de nos Produits soit «
                telle quelle » et « sous réserve de disponibilité ». Comme mentionné ci-dessus, nous
                ne faisons aucune représentation et n’offrons aucune garantie par rapport à la
                disponibilité de nos Services, y compris et sans s’y limiter, à leur exhaustivité,
                leur exactitude et leur fiabilité.
            </p>
            <p>
                <strong>10.8.</strong> En cas de litige avec un ou plusieurs Utilisateurs ou Clients
                Activix, vous acceptez de nous (ainsi que nos dirigeants, administrateurs,
                actionnaires, agents, filiales, coentreprises, employés et concédants) libérer de
                toute réclamation, toute demande et tout dommage découlant d’une façon ou d’une
                autre de ce litige.
            </p>
            <p>
                <strong>10.9.</strong> Vous acceptez de nous indemniser (et nos dirigeants,
                administrateurs, actionnaires, agents, filiales, coentreprises, employés et
                concédants) pour toute réclamation et toute demande, y compris les honoraires
                judiciaires et extrajudiciaires raisonnables encourus en raison de votre violation
                des présentes Conditions ou en raison de tout Contenu que vous soumettez, publiez,
                transmettez ou rendrez disponible via les Services, votre utilisation des Services,
                votre connexion aux Services, ou votre violation des droits d'autrui de même que de
                votre violation de la loi.
            </p>
            <p>
                <strong>10.10.</strong> Vous reconnaissez que nous ne sommes pas responsables des
                événements imprévisibles, tels que les événements de force majeure, ou tout autre
                événement hors de notre contrôle.
            </p>
            <p>
                <strong>10.11.</strong> Activix Inc. étant une entité juridique dûment incorporée,
                ses actionnaires, administrateurs, dirigeants, employés et consultants ne pourront,
                en aucune façon, être tenus responsables de tout dommage découlant de quelque
                manière que ce soit à l’accès et à l’utilisation de nos Produits.
            </p>
            <p>
                <strong>10.12.</strong> Sauf indication contraire, toute exclusion et limitation de
                responsabilité s’appliquent également aux Conditions additionnelles, le cas échéant.
            </p>

            <h4>11. Dispositions finales</h4>
            <p>
                <strong>11.1.</strong> Activix Inc. peut, à son entière discrétion, modifier,
                enrichir ou supprimer ces Conditions, en totalité ou en partie, à des fins
                juridiques, techniques ou réglementaires, si elle le juge nécessaire ou à la suite
                d'une modification des Services fournis, de la nature ou de la présentation des
                Produits. Votre accès continu ou votre utilisation de nos Produits indique que vous
                êtes d’accord avec ces changements.
            </p>
            <p>
                <strong>11.2.</strong> Sauf indication contraire dans les présentes Conditions, tout
                avis de vous à nous doit être envoyé par écrit à notre adresse de courriel au
                info@activix.ca et tout avis de nous à vous sera affiché sur les Produits que vous
                utilisez en temps opportun.
            </p>
            <p>
                <strong>11.3.</strong> Si l'une des dispositions des présentes Conditions est jugée
                invalide par un tribunal compétent, y compris, mais sans s'y limiter, les
                dispositions relatives aux exclusions et aux limitations de responsabilité
                susmentionnées, la disposition invalide ou inapplicable sera réputée remplacée par
                une disposition valide qui correspondra à l'intention de la disposition originale et
                les autres dispositions des Conditions resteront en vigueur.
            </p>
            <p>
                <strong>11.4.</strong> Vous ne pouvez pas non plus céder vos droits et obligations
                en vertu du présent accord à une autre partie sans obtenir notre consentement
                préalablement par écrit.
            </p>
            <p>
                <strong>11.5.</strong> L'Utilisateur reconnaît expressément que les Produits seront
                réputés être basés à Montréal, dans la province du Québec au Canada. Les présentes
                Conditions sont régies et interprétées conformément aux lois de la province du
                Québec et aux lois fédérales du Canada qui leurs sont applicables et, à moins d’une
                disposition d’ordre public prévue à la loi, toute poursuite judiciaire intentée en
                vertu des présentes Conditions sera de juridiction exclusive des tribunaux du
                district judiciaire de Montréal.
            </p>
            <p>
                <strong>11.6.</strong> Les présentes Conditions (et toutes autres dispositions
                mentionnées précédemment) constituent l'intégralité des droits et obligations qui
                nous lient à vous relativement à l’accès et à l’utilisation des Produits et elles
                remplacent toute communication et proposition antérieure ou actuelle, qu’elle soit
                électronique, orale, ou écrite. Une version imprimée de ces Conditions et de toute
                information fournie sous format électronique est admissible en preuve dans la même
                mesure et selon les mêmes conditions que les autres moyens de preuve.
            </p>
        </div>
    </div>
</template>
